import { OrderHoldSubtype, OrderHoldType } from '@invenco/common-domain/enums';
import { OrderCurrency, OrderStatus } from '@invenco/sales-interface/interfaces';

import { OrdersQueryQuery } from '@/graphql/generated/seller/graphql';
import { convertDateTimeToISO } from '@/shared/helpers';
import { ListData } from '@/shared/types';

export type OrderListItem = {
  id: string;
  name: string;
  reference: string | null;
  accountId: string;
  status: OrderStatus | null;
  currency: OrderCurrency;
  channelId: string | null;
  channelName: string | null;
  customerName: string | null;
  qtyOrdered: number;
  totalPrice: number | null;
  orderedAt: string | null;
  orderHolds?: {
    id: string;
    type: OrderHoldType;
    subtype: OrderHoldSubtype | null;
    description: string | null;
    createdAt: string;
  }[];
};

export class OrderListMapper {
  static toData(response: OrdersQueryQuery): ListData<OrderListItem> {
    const total = response?.ordersAggregate?._count ?? 0;
    const data = Array.isArray(response.orders)
      ? response.orders.map((order) => ({
          id: order.id,
          name: order.name,
          accountId: order.accountId,
          // TODO: manage fields in GraphQL are erroneously typed as nullable. Remove non-null assertions when fixed.
          reference: order.reference ?? null,
          currency: order.currency as OrderCurrency,
          channelId: order.channelId ?? null,
          customerName: order.customerName ?? null,
          channelName: order.channelName ?? null,
          status: order.status ? (order.status as OrderStatus) : null,
          qtyOrdered: order.qtyOrdered,
          totalPrice: order.totalPrice ?? null,
          orderedAt: order.orderedAt ? convertDateTimeToISO(order.orderedAt) : null,
          orderHolds: order.orderHolds?.map((hold) => ({
            id: hold.id,
            type: hold.type as OrderHoldType,
            subtype: hold.subtype ? (hold.subtype as OrderHoldSubtype) : null,
            description: hold.description ?? null,
            createdAt: convertDateTimeToISO(hold.createdAt),
          })),
        }))
      : [];
    return { data, total };
  }
}
